/* eslint-disable @typescript-eslint/naming-convention */
export interface ProjectErrorType {
  code: ProjectErrors | 'custom' | string;
  message: string;
  details?: string;
  getUserMessage: () => string;
}

export enum ProjectErrors {
  generic = 'Something went wrong',
  genericTryAgain = 'Something went wrong. Please try again.',

  signupEmailInUse = 'Email address is already in use. Please try again with a new email address.',
  authExistingAccount = 'An account already exists with the same email address but different sign-in credentials',
  signupInvalidEmail = 'The email address you entered address is invalid. Please try again.',
  loginUserNotFound = 'User not found. Please verify the credentials and try again',
  loginWrongPassword = 'Password is incorrect. Please verify the password and try again.',
  authInvalidUserId = 'Invalid user. Canceling the login action.',

  userIsNotAdmin = 'The user you tried to login with does not have access to the Admin Dashboard. Please login with an admin account',
  userIsNotSuperUser = 'This action is enabled only for super users. Please login with a super user account and try again.',

  invalidProfile = 'The profile is invalid',
  invalidLesson = 'The lesson is invalid',
  invalidContentGroup = 'The content group is invalid',
  invalidAuthor = 'The author is invalid',
  invalidCampaign = 'The campaign is invalid',
  invalidCategory = 'The category is invalid',
  invalidAuthorCategory = 'The author category is invalid',
  invalidGoal = 'The goal is invalid',
  invalidFormQuestion = 'The form question is invalid.',
  invalidPillar = 'The pillar is invalid',
  invalidPromotion = 'The promotion is invalid',
  invalidNetwork = 'The network is invalid',
  invalidUserPath = 'The user path is invalid',
  invalidDailyMissionTemplate = 'The daily mission is invalid',
  invalidLevelDefinition = 'The level is invalid',
  invalidMentorBoard = 'The mentor board is invalid',
  invalidMentorShort = 'The video is invalid',

  noUserFoundWithID = 'User not found. Please try again using another ID.',
  noUserFoundWithEmail = 'User not found. Please try again using another email.',
  emailBelongsToDifferentAccount = 'This email belongs to a different account. No email was sent.',
  displayedUserChanged = 'The displayed user changed. No email was sent.',

  failedToMoveSection = 'Failed to move section. Please try again',
  failedToSaveSection = 'Failed to save section. Please try again',
  failedToDeleteSection = 'Failed to delete section. Please try again',

  superUserPermissions = 'You do not have the permission to do the following action.',
  cannotChangeSection = 'You cannot delete / change this section because it is only one of a kind.',

  unauthenticated = 'You are not authenticated. Please login and try again.',
  unauthorized = 'You are not authorized to perform this action.',
  impersonationInvalidArgument = 'Invalid argument. You cannot impersonate yourself.',

  exp_timestamp_not_found = 'No active subscription was found.',
}
